module.exports = __webpack_public_path__ + "img/typewriters.e95be5da.gif";